/* 用户统一state */

import homeState from './state.home';
import { getUserInfo } from '../../lib/auth';

const initUserInfo = {
  id: null,
  encUserId: null,
  name: null,
  avatar: null,
  token: null,
  isHaveMobile: null
};
const nowUserInfo = getUserInfo();
const userInfo = Object.assign({}, initUserInfo, nowUserInfo);

const userState = Object.assign({
  userInfo, // 用户信息
  userCourse: {  // 我的开讲课程
    list: [],
    hasNextPage: true
  },
  userSerialCourse: {  // 我的开讲 系列课
    list: [],
    hasNextPage: true
  }, // 我的开讲数据
  combineCourse: {  // 我的开讲组合课
    list: [],
    hasNextPage: true
  },
  courseRecommends: [], // 更多推荐课程接口
  hotLabelList: [],
  serialList: {
    type: null,
    list: [],
    hasNextPage: false,
    curpage: 0
  }, // 系列课列表
  sedCodeInfo: null, // 发送短信验证码返回的数据
  bindMobileInfo: null, // 绑定手机号返回信息
  payStatus: {
    courseId: null,  // 课程id
    ordernum: null,  // 订单号
    status: 0     // 成功1，默认0
  },
  treeCoinInfo: {
    balance: 0,
    accountList: [],
    list: [],
    hasNextPage: true
  },
  userIssues: {},
  myTinyAudio: {
    myTinyAudioList: [],
    hasNextPage: true
  },
  myTinyAlbum: {
    myTinyAlbumList: [],
    hasNextPage: true
  },
  myTinyVideo: {
    myTinyVideoList: [],
    hasNextPage: true
  },
  myTinyVideoAlbum: {
    myTinyVideoAlbumList: [],
    hasNextPage: true
  },
  groupAlbum: { // 组合课程列表
    groupAlbumList: [],
    hasNextPage: true
  },
  audio5: null,  // 全局audio5
  lamaRecommends: [], // 更多免费推荐课程接口，小时光使用
  freeTinyCourse: { // 免费小微课
    list: [],
    hasNextPage: true
  },
  myCourse: { // 我的课程列表
    list: [],
    hasNextPage: true,
    isquerynostart: null,
    indexstart: null,
    nextPageNum: null,
    curpage: null
  },
  indexInfo: { // 新版首页
    pageInfo: '', // 首页数据
    courseRemind: { // 提示条
      url: { name: 'MyCourse' }
    },
    hotCourse: {
      index: 1,
      course: {}
    },
    recommendList: [], // 为你推荐
    hasNextPage: true,
    nextPageNum: 1,
    closeStatus: true, // 提示条是否显示
    indexModuleList: {}  // 首页模块列表
  },
  isSort: false, // 订阅课子课列表中是否进行了排序
  columnList: { // 订阅课列表
    list: [],
    hasNextPage: true
  },
  leaveMessageList: { // 子课程详情留言列表
    dataList: [],
    curpage: 1,
    hasNextPage: false,
    buyRemind: null,
    totalCount: 0
  },
  newCourseInfo: {}, // 新版的课程详情
  myIncome: { // 订阅课列表
    list: [],
    hasNextPage: true,
    counts: 0,
    sumAmount: 0
  },
  constantData: [], // 获取后台配置的静态数据
  vipInfo: {  // VIP 静态数据
    vipLogo: null, // viplogo
    vipFreeLogo: null, // 会员免费听logo
    vipFreeText: null, // 会员免费听文案
    vipBindLink: null, // 开通会员的链接
    vipBindText: null // 提示开通会员的文本
  },
  memberFreeCourse: { // 会员免费听
    catagorys: [],
    catagoryid: 0,
    list: [],
    hasNextPage: true,
    courseNum: 0,
    curpage: 0
  }
}, homeState);

export default userState;



// WEBPACK FOOTER //
// ./src/store/user/state.user.js